export default __webpack_public_path__ + "static/media/IconMain.500fb24f.svg";